var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"d-flex align-items-center",attrs:{"variant":"outline-secondary","size":"sm","title":"Save columns"},on:{"click":_vm.saveColumns}},[_c('icon',{staticClass:"mr-1",attrs:{"name":"save"}}),_vm._v("\n  "+_vm._s(_vm.$t('buttons.common.save_columns'))+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49fab2aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SaveColumnsBtn.vue
// module id = null
// module chunks = 